import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, Badge, SectionTitle } from "@/components/ui-hud";
import { Plane, Users2, ArrowRight, Loader2, Globe2 } from "lucide-react";

export default function CharterRequestList() {
  const [reqs, setReqs] = useState(null);

  useEffect(() => {
    api.get("/charter-requests?status=open&limit=50").then((r) => setReqs(r.data.requests || [])).catch(() => setReqs([]));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="flex items-start justify-between flex-wrap gap-3 mb-6">
        <SectionTitle overline="// OPEN CHARTER REQUESTS" title="Bid on open trips." subtitle="Public charter quote requests from PJP customers. Operators submit their fleet + price. Customer picks a winner." />
        <Link to="/charter-request" data-testid="new-charter-cta" className="btn btn-primary" style={{background:"#4B9CFF", borderColor:"#4B9CFF"}}>REQUEST A QUOTE <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>

      {reqs === null && <div className="text-center py-16 text-white/50"><Loader2 className="h-6 w-6 animate-spin inline mr-2" /> Loading…</div>}
      {reqs && reqs.length === 0 && (
        <Card><div className="text-center py-8 text-white/50 mono">No open charter requests right now.</div></Card>
      )}
      {reqs && reqs.length > 0 && (
        <div className="grid gap-3">
          {reqs.map((r) => (
            <Link key={r.id} to={`/charter-requests/${r.id}`} data-testid={`req-${r.id}`}>
              <Card className="hover:border-cyan/40 transition-colors">
                <div className="flex flex-wrap items-baseline gap-3 mb-2">
                  <div className="mono text-lg font-bold text-cyan">
                    {(r.routing || [r.departure_icao, r.destination_icao]).join(" → ")}
                  </div>
                  {r.is_international && <span className="mono text-[10px] px-2 py-0.5 rounded-full border border-orange-hud/40 text-orange-hud bg-orange-hud/10 inline-flex items-center gap-1"><Globe2 className="h-3 w-3" /> INTL</span>}
                  <Badge tone="mono"><Users2 className="h-3 w-3 inline mr-1" /> {r.passengers} pax</Badge>
                  <Badge tone="cyan">{r.aircraft_class_pref || "Any class"}</Badge>
                  {r.budget_usd && <span className="mono text-sm text-avail">${r.budget_usd.toLocaleString()}</span>}
                </div>
                <div className="mono text-xs text-white/50">Start {r.trip_start}{r.trip_end ? ` · End ${r.trip_end}` : ""}</div>
                {r.special_requests && <div className="text-sm text-white/70 mt-2 line-clamp-2">{r.special_requests}</div>}
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
